import React from 'react';
import { useSelector } from 'react-redux';

import { selectWidgetSettings } from 'src/store/slice/payment/state';
import { useCustomSearchParams } from 'src/hook';

import DropdownLanguage from 'src/components/dropdownLanguage';

import './merchant-info.scss';

const MerchantInfo: React.FC = (): JSX.Element | null => {
  const { parsedMerchantInformation } = useCustomSearchParams();

  const widgetSettings = useSelector(selectWidgetSettings);

  const { merchantName } = parsedMerchantInformation || widgetSettings || {};

  return (
    <section className="merchant-info">
      {!!merchantName && <p className="merchant-info-name">{merchantName}</p>}

      <DropdownLanguage />
    </section>
  );
};

export default MerchantInfo;
